import {createContext} from "react";
import {ParticipationType} from "../../../model/ParticipationType";
import {SpeakerInvitationDay} from "../../../model/SpeakerInvitationCreateMessage";

export interface InvitationDatesContextState {
    dates: SpeakerInvitationDay[];
    onSlotChange: ((slotDate: Date, uiId: number) => void) | undefined;
    onParticipationTypeChange: ((slotDate: Date, participationType: ParticipationType) => void) | undefined;
}

export const InvitationDatesContext = createContext<InvitationDatesContextState>({
    dates: [],
    onSlotChange: undefined,
    onParticipationTypeChange: undefined
});